const i18n_fields = {
  EN: [
    { key: 'created_at', thStyle: 'width: 10%', sortable: true, label: 'Time' },
    { key: 'username', sortable: true, label: 'Username'},
    { key: 'source', sortable: false, label: 'From' },
    { key: 'addr', sortable: false, label: 'IP Address' },
    { key: 'action', sortable: false, label: 'Action' },
    { key: 'agent', sortable: false, label: 'Agent' },
    { key: 'func', sortable: false, label: 'Select' },
  ],
  KO: [
    { key: 'created_at', thStyle: 'width: 10%', sortable: true, label: '시각' },
    { key: 'username', sortable: true, label: '사용자명'},
    { key: 'source', sortable: false, label: '요청 서비스' },
    { key: 'addr', sortable: false, label: 'IP 주소' },
    { key: 'action', sortable: false, label: '행위' },
    { key: 'agent', sortable: false, label: '요청 브라우저 정보' },
    { key: 'func', sortable: false, label: '상세' },
  ],
  JP: [
    { key: 'created_at', thStyle: 'width: 10%', sortable: true, label: 'Time' },
    { key: 'username', sortable: true, label: 'ユーザー名'},
    { key: 'source', sortable: false, label: 'From' },
    { key: 'addr', sortable: false, label: 'IPアドレス' },
    { key: 'action', sortable: false, label: 'アクション' },
    { key: 'agent', sortable: false, label: 'エージェント' },
    { key: 'func', sortable: false, label: '選択' },
  ]
}

const fields = { i18n_fields }

export default fields